import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4042 8.59375C16.406 8.96102 16.406 9.35102 16.406 9.76563C16.406 13.2643 16.406 15.0137 15.3192 16.1006C14.2322 17.1875 12.4828 17.1875 8.98416 17.1875C5.48546 17.1875 3.73611 17.1875 2.64919 16.1006C1.56229 15.0137 1.56229 13.2643 1.56229 9.76563C1.56229 6.26692 1.56229 4.51757 2.64919 3.43066C3.73611 2.34375 5.48546 2.34375 8.98416 2.34375C9.39877 2.34375 9.78877 2.34375 10.156 2.34556",
			stroke: "currentColor",
			strokeWidth: 1.17188,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4531 1.56262L14.6546 2.10718C14.9188 2.82123 15.0509 3.17826 15.3114 3.43871C15.5719 3.69916 15.9289 3.83127 16.643 4.0955L17.1875 4.297L16.643 4.4985C15.9289 4.76272 15.5719 4.89484 15.3114 5.15529C15.0509 5.41573 14.9188 5.77276 14.6546 6.48682L14.4531 7.03137L14.2516 6.48682C13.9874 5.77276 13.8553 5.41573 13.5948 5.15529C13.3344 4.89484 12.9773 4.76272 12.2633 4.4985L11.7188 4.297L12.2633 4.0955C12.9773 3.83127 13.3344 3.69916 13.5948 3.43871C13.8553 3.17826 13.9874 2.82123 14.2516 2.10718L14.4531 1.56262Z",
			stroke: "currentColor",
			strokeWidth: 1.17188,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.28519 12.75L9.89684 7.91505C9.97945 7.66719 10.2114 7.5 10.4727 7.5C10.734 7.5 10.9659 7.66719 11.0485 7.91505L12.6602 12.75M9.16019 11H11.7852",
			stroke: "currentColor",
			strokeWidth: 1.17188,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.62512 7.5V10.125V12.75",
			stroke: "currentColor",
			strokeWidth: 1.17188,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAiImage;
